const orderSourceAddressChoice = [
    { id: 0, name: 'Golden Record' },
    { id: 1, name: 'Endereço do Painel' },
    { id: null, name: 'Não informado' }
]

export default orderSourceAddressChoice;
